export interface GolferField {
    id: string;
    label: string;
    required: boolean;
}

export interface GolferDetail extends GolferField {
    value: string;
}

export const MAX_GOLFER_FIELDS = 10;
export const MAX_GOLFER_VALUE_LENGTH = 256;
export const DEFAULT_GOLFER_FIELDS: GolferField[] = [
    {id: 'name', label: 'First and Last Name', required: true}
];

// An absent configuration keeps legacy checkout; an explicit [] asks for no details.
export function resolveGolferFields(raw: unknown): GolferField[] {
    if (!Array.isArray(raw) || raw.length > MAX_GOLFER_FIELDS) return DEFAULT_GOLFER_FIELDS;
    const ids = new Set<string>();
    const fields: GolferField[] = [];
    for (const field of raw) {
        if (!field || typeof field.id !== 'string' || !/^[a-zA-Z0-9_-]{1,64}$/.test(field.id)
            || ids.has(field.id) || typeof field.label !== 'string'
            || !field.label.trim() || field.label.trim().length > 80
            || typeof field.required !== 'boolean') return DEFAULT_GOLFER_FIELDS;
        ids.add(field.id);
        fields.push({id: field.id, label: field.label.trim(), required: field.required});
    }
    return fields;
}

export function validateGolferDetails(fields: GolferField[], values: Record<string, string>): string | null {
    for (const field of fields) {
        const value = (values[field.id] ?? '').trim();
        if (field.required && !value) {
            return field.id === 'name'
                ? 'Please enter your name before placing the order.'
                : `Please enter ${field.label} before placing the order.`;
        }
        if (value.length > MAX_GOLFER_VALUE_LENGTH) {
            return `${field.label} must be ${MAX_GOLFER_VALUE_LENGTH} characters or fewer.`;
        }
    }
    return null;
}

export function snapshotGolferDetails(fields: GolferField[], values: Record<string, string>): GolferDetail[] {
    return fields.map(field => ({...field, value: (values[field.id] ?? '').trim()}));
}
